import React from "react";
import { useWatch } from "react-hook-form";
import { NumberControl } from "@tiny/components";
import { useStyles } from "../Value.styles";

interface NumberRangeValueProps {
  prefixName: string;
  disabled?: boolean;
}

function NumberRangeValue(props: NumberRangeValueProps) {
  const { prefixName, disabled } = props;

  const classes = useStyles();

  const value = useWatch({
    name: `${prefixName}.value`,
  });

  const nameFrom = `${prefixName}.value.value[0]`;

  const nameTo = `${prefixName}.value.value[1]`;

  const validateTo = (v: number | string | null) => {
    if (typeof v === "number" && !isNaN(v)) {
      if (value?.value?.[0] > v) {
        return "Lower than from";
      }
    }
  };

  return (
    <div className={classes.root}>
      <NumberControl
        name={nameFrom}
        className={classes.field}
        placeholder="From"
        aria-label="Condition from"
        showHelperTextMargin
        required
        disabled={disabled}
        watchValue
      />
      <NumberControl
        name={nameTo}
        className={classes.field}
        placeholder="To"
        aria-label="Condition to"
        showHelperTextMargin
        required
        validate={validateTo}
        disabled={disabled}
        watchValue
      />
    </div>
  );
}

export default NumberRangeValue;
